
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finance/[slug]",
      function () {
        return require("private-next-pages/finance/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finance/[slug]"])
      });
    }
  